/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsContainerFindingsStatusQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsContainerFindingsStatusQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsContainerFindingsStatusQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsContainerFindingsStatusQueryOperator>): AppSecopsContainerFindingsStatusQueryOperator {
        let obj = Object.assign(new AppSecopsContainerFindingsStatusQueryOperator(), model);
        AppSecopsContainerFindingsStatusQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsContainerFindingsStatusQueryOperator>): AppSecopsContainerFindingsStatusQueryOperator {
        if (!model) return null;
        return AppSecopsContainerFindingsStatusQueryOperator.newInstance(<AppSecopsContainerFindingsStatusQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsContainerFindingsStatusQueryOperator) {
        if (!obj) return;

        models.AppSecopsContainerFindingsStatusQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsContainerFindingsStatusQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsContainerFindingsStatusQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Finding status to include
     */
    statuses: Array<models.SecurityFindingsStatus>;

}
